import { render, staticRenderFns } from "./WalletCardPreview.vue?vue&type=template&id=3cb911e2&scoped=true&"
import script from "./WalletCardPreview.vue?vue&type=script&lang=js&"
export * from "./WalletCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardPreview.vue?vue&type=style&index=0&id=3cb911e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb911e2",
  null
  
)

export default component.exports